export const DEFAULT_TIME_ZONE = 'UTC'
export const NOW_PARAM = 'now'
export const DURATION_PREFIX = `${NOW_PARAM}-`

// We fetch more than requested time range so the curve is connected to the points preceding and succeeding the timeline.
// Therefore, we use a factor, that extends the given time range.
// A factor of 0.5 means the time margin is 50% of the initial time range,
// so the resulting duration between start and end would be 1 + 0.5 (start) + 0.5 (end) = 2 times as long
export const DEFAULT_TIME_MARGIN_FACTOR = 0.25
